import React, { useRef, useState } from 'react';
import styled from 'styled-components';
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';
import {Autocomplete, TextField} from '@mui/material';
import { HeadingWrap, CommonButton, Span,  BackButtonSpan } from '../../../../Styles/CommonStyles';
import { useGetUsersQuery } from '../../../../features/users/usersApiSlice';
import { Span as OriginalSpan } from '../../../../Styles/CommonStyles';
import nameStringFn from '../../../../data/nameStringFn';
import { useGetofficesQuery } from '../../../../features/offices/officesApiSlice';
import { useGetconsummasterQuery } from '../../../../features/consummaster/consummasterApiSlice';
import { useSelector } from 'react-redux';
import { useGetconsumfinalQuery, useUpdateconsumfinalMutation } from '../../../../features/consumfinal/consumfinalApiSlice';
import { useGetAssetsFinalQuery } from '../../../../features/addassets/addassetfinalApiSlice';
import { useGetpartnumberQuery } from '../../../../features/partnumber/partnumberApiSlice';
import RemoveIcon from '@mui/icons-material/Remove';
import AddIcon from '@mui/icons-material/Add';
import useAuth from '../../../../features/hooks/useAuth';
import { useGetConsumTransactionsQuery } from '../../../../features/consumtransactions/consumTransApiSlice';
import { useUploadFileMutation } from '../../../../features/fileupload/fileuploadApiSlice';





const StartAlignedSpan = styled(OriginalSpan)`
  align-items: flex-start;
`
const Addconsumformcont = styled.div`
  display: flex;
  margin-left: 10px;
`
const LabelInputWrapper = styled.div`
  margin-bottom:5px;
  min-height: 60px;
  margin-right:20px;
`

const Container = styled.div`
  width: 100%;
`
const BackArrowContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-right: 20px;
  cursor: pointer;
`
const Wrapper = styled.div`
  width: 100%;
`
const AllWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  align-items: space-around;
  flex-grow: 1;
  row-gap: 50px;
  margin-bottom: 20px;
`
const OptionContainer = styled.div`
  width:350px;
  display: flex;
  height:150px;
  background-color:#fff;
  /* align-items: center;
  justify-content: center; */
  color: #58548E;
  font-family: "Roboto","Helvetica","Arial",sans-serif;
  font-size: 1.2857142857142856rem;
  line-height: 1.334;
  letter-spacing: 0em;
  margin-left: 24px;
  font-weight: 700;
  cursor: pointer;
  position: relative;
  transition: box-shadow 0.3s;
  &:hover{
      box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;
  }
`
const InnerContainer = styled.div`
  display:flex;
  border-left: 3px solid #955EFF;
  align-items: center;
  position: absolute;
  top: 20%;
  bottom: 20%;
  padding: 25px;
`
const CustomFileUploadButton = styled.label`
  /* Add your desired button styles */
  background-color: #4caf50; /* Green */
  color: white;
  padding: 10px 15px;
  border: none;
  border-radius: 5px;
  margin-right:5px;
  cursor: pointer;
`
const SelectFileReset = styled.button`
  background-color: transparent;
  color: #999;
  border: none;
  font-size: 35px;
  cursor: pointer;
  padding: 0;
  margin-left:2px;
`
const OptWrap = styled.div``

const SingleUserWrap = styled.div`
  display: flex;
`
const EmailSelectWrap = styled.div`
  margin-right: 20px;
`
const SingleoffCont = styled.div`
`

const SingleSelectCont = styled.div`
`
const OfficeSelectWrap = styled.div`
  margin-bottom: 20px;
`
const InputFile = styled.input`
  width: 180px;
  display: none;
`
const Issuebutton = styled(CommonButton)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 10vw;
  height: 50px;
  background-color: teal;
  margin-right: 30px;
  cursor: pointer;
  border-radius: 10px; 
`
const ViewButton = styled.button`
  background-color: #4caf50; /* Green */
  color: white;
  padding: 10px 15px;
  border: none;
  border-radius: 5px;
  margin-right:5px;
  margin-left: 5px;
  cursor: pointer;  
`
const MultiUserCont = styled.div``
const MultiUserWrap = styled.div``
const UserSelectWrap = styled.div``
const UploadPdfWrapper = styled.div`
  display: flex;
  align-items:center;
`
const getCurrentDateISO = () => {
  const today = new Date();
  return today.toISOString();
}

const hasValidQuantity = (data) => {
  // Ensure that the input is a valid, non-empty array

  if (!Array.isArray(data) || data.length === 0) {
    console.error("Invalid input: data must be a non-empty array.");
    return false; // Return false if data is not a valid array or is empty
  }

  // Check if all objects in the array have a quantity greater than 0
  return data.every(item => {
    // Ensure that 'quantity' exists and is a valid number greater than 0
    const quantity = parseInt(item.quantity, 10);
    return !isNaN(quantity) && quantity > 0;
  });
};

const SurrenderConsum = () => {
  const [byEmailClicked, setByEmailClicked] = useState(false);
  const [byOfficeClicked, setByOfficeClicked] = useState(false);
  const [selectedUserbyOff, setSelectedUserbyOff] = useState();
  const [selectedUser, setSelectedUser] = useState({});
  const [offsingle, setOffsigle] = useState();
  const [selectedOff1, setSelectedOff1] = useState();
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [addSpecIndex, setAddSpecIndex] = useState(1);
  const [selectedConsum, setSelectedConsum] = useState([]);
  const [selectedfile, setSelectedFile] = useState(null);
  const inputPdfFile = useRef(null);
  const [consTransOption, setConsTransOption] = useState({
    transac_id:"",
    req_id: "",
    consumable:[],
    partnumber:[],
    asset_id: [],
    from_quantity:null,
    to_quantity:null,
    transac_type: [],
    from_userid: [],
    to_userid:[],
    from_office: [],
    to_office:[],
    desig: [],
    store: [],
    time_from:null ,
    time_to: null,
  })
  
  
  
  const { id, email } = useAuth();

  const [emailId, setEmailId] = useState("");

  let user_current_office = (useSelector((state) => state.office.off));

  const [uploadFile, { isLoading: isUploading }] = useUploadFileMutation();
  const [updateconsumfinal, { isLoading: isUpdating }] = useUpdateconsumfinalMutation();

  const folderName = "directsurrcons";

  
  const { users } = useGetUsersQuery('userslist', {
    selectFromResult: ({ data }) => ({
      users: data?.entities
    }),
  })

  const { offices } = useGetofficesQuery('offices', {
    selectFromResult: ({ data }) => ({
      offices: data?.entities
    }),
  })

  const {allassets} = useGetAssetsFinalQuery('allassets', {
    selectFromResult: ({ data }) => ({
      allassets: data?.entities
    }),
  })

  const {consumablemaster} = useGetconsummasterQuery('cosummaster', {
    selectFromResult: ({ data }) => ({
      consumablemaster: data?.entities
    }),
  })

  const {partnumber} =   useGetpartnumberQuery('partno', {
    selectFromResult: ({ data }) => ({
      partnumber: data?.entities
    }),
  })
  const hasValidField = (consTransOption.to_userid.length > 0);

  const { data: consTrans } = useGetConsumTransactionsQuery(consTransOption, {
    skip: !hasValidField
  });

  const handleviewFile = () =>{
    window.open(URL.createObjectURL(selectedfile), '_blank');
  }

  const { data: consumfinal, isLoading, isError } = useGetconsumfinalQuery({partnos: selectedConsum.map(x => x.partno), store:user_current_office }, {
    selectFromResult: ({ data, isLoading, isError }) => {
      // Transform normalized entities into an object indexed by partno for easy lookup
      const consumfinalByPartno = {};
      if (data?.entities) {
        Object.values(data.entities).forEach(item => {
          if (item?.partno) {
            consumfinalByPartno[item.partno] = item;
          }
        });
      }
      return {
        data: consumfinalByPartno,
        isLoading,
        isError
      };
    }
  });
  
  const handleEmailSelect = (event, newValue) => {
    setEmailId(newValue);
    if(Object.keys(newValue)?.length){
        const tempUser = Object.values(users).find(x => x.email === newValue.label);
        setSelectedUser(tempUser);
        setConsTransOption(prevState => ({
          ...prevState,
          to_userid: [...prevState.to_userid, tempUser.id]  // Add a new item to the consumable array
        }));
        
    } else {
        setSelectedUser({})
    }
    setOffsigle()
  }

  const handleSelectOffice = (event, newValue) => {
    setSelectedOff1(newValue);
    const tempFilteredUsers = Object.values(users).filter(x => (x.office.mainCharge === newValue || x.office.additionalCharge.includes(newValue)));
    setFilteredUsers(tempFilteredUsers);
    if(newValue?.length){
      setConsTransOption(prevState => ({
        ...prevState,
        to_office: [...prevState.to_office, newValue] 
      }));
    } else {
      setConsTransOption(prevState => ({
        ...prevState,
        to_office: []
      }));
    }
  }

  const handleselectedUserbyOff = (event, newValue) => {
    setSelectedUserbyOff(newValue);
    setEmailId({"label":newValue?.value?.email, "value":newValue?.value?.id});
    if(newValue?.value?.id?.length){
      setConsTransOption(prevState => ({
        ...prevState,
        to_userid: [...prevState.to_userid, newValue?.value?.id]  // Add a new item to the consumable array
      }));
    } else {
      setConsTransOption(prevState => ({
        ...prevState,
        to_userid: []  
      }));
    }

  }

  const onClickaddicon = () =>{
    // let tempValue = {...value};
    // tempValue[`type${addSpecIndex}`] = tempValue[`type${addSpecIndex-1}`];
    // tempValue[`superioroffice${addSpecIndex}`] = tempValue[`superioroffice${addSpecIndex-1}`];
    // setValue(tempValue);
    setAddSpecIndex(addSpecIndex+1);
  }

  const onClickremoveicon = () =>{
    if(addSpecIndex > 1){
      setAddSpecIndex(addSpecIndex-1)
      let tempSelectedConsum = [...selectedConsum];
      delete tempSelectedConsum[addSpecIndex-1];
      setSelectedConsum(tempSelectedConsum);
    }
  }


  const handleSelectConsum = (event, newValue, i, name) => {
    let tempSelectedConsum = [...selectedConsum];
  
    if (tempSelectedConsum[i]) {
      if(event.target.name === "quantity" && event.target.value && consumfinal?.[selectedConsum[i]?.partno]?.balance_order_quantity < parseInt(event.target.value, 10) ){
        return alert("Sufficient Quantiy not available")
      }
      // Update the object at index 'i' with the dynamic key 'name' and new value 'newValue'
      tempSelectedConsum[i] = event.target.name?.length? { ...tempSelectedConsum[i], [event.target.name]: event.target.value.length? Number(event.target.value): event.target.value }:{ ...tempSelectedConsum[i], [name]: newValue } ;
    } else {
      // Ensure we push a new object at the correct index (if 'i' is greater than the current array length)
      while (tempSelectedConsum?.length <= i) {
        tempSelectedConsum.push({});
      }
      // Set the key 'name' with the value 'newValue' for the new object at index 'i'
      tempSelectedConsum[i] = event.target.name?.length?{ [event.target.name]: event.target.value.length? Number(event.target.value): event.target.value }: { [name]: newValue };
    }
    if(["partno", "consumable"].includes(name)){
      let dockey = name=== "consumable"? "consumable":"partnumber";
      if(newValue?.length){
        setConsTransOption(prevState => ({
          ...prevState, [dockey]: [...prevState[dockey], newValue]
        }))
      }
      if(newValue === null){
        setConsTransOption(prevState => ({
          ...prevState, [dockey]: []
        }))
      }
    }

    // Update the state with the modified array
    setSelectedConsum(tempSelectedConsum);

  };

  const deleteSelectFile = () => {
    if (inputPdfFile.current) {
      inputPdfFile.current.value = null;
      inputPdfFile.current.type = "text";
      inputPdfFile.current.type = "file";
      setSelectedFile(null);
    }
  }

  // handle file upload
  const handlePdfFileChange = (event) => {
  const file = event.target.files[0];
  if (file) {
    if (file.type === 'application/pdf') {
      setSelectedFile(file)       
    } else {
      alert('Please select only PDF file.');
      event.target.value = null;
      }
    }
  }

  const handlePdfUploadButtonClick = () => {
    inputPdfFile?.current?.click();
  };


  const backClickedHandler = () => {
    setByEmailClicked(false);
    setByOfficeClicked(false);
    // setSelectedConsum([]);
    setEmailId("");
    setOffsigle();
    // setAddSpecIndex(1)
    setSelectedUserbyOff();
    setSelectedOff1();
    setSelectedUser();
  }

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    const finalSelectedUser = selectedUserbyOff? selectedUserbyOff.value:selectedUser;
    const userid = finalSelectedUser._id;
    const userOffice = offsingle? offsingle.value:selectedOff1;
    let conTransObj = {
      transac_id:`DSCONSUM-${Date.now().toString(36)}`,
      req_id:"",
      transac_type:"DirectSurrender",
      consumable:selectedConsum[0]?.consumable,
      partnumber:selectedConsum[0]?.partno,
      quantity:selectedConsum[0]?.quantity,
      asset_id:selectedConsum[0]?.assettag? selectedConsum[0]?.assettag?.value?.oem_tag:"",
      from_userid:finalSelectedUser?.email ,
      from_office:userOffice ,
      from_desig:finalSelectedUser.designation[userOffice] ,
      from_store:user_current_office,
      to_userid:email,
      to_office:user_current_office,
      to_desig:users[id].designation[user_current_office],
      to_store:user_current_office,
      pdfPath:"",
      time_stamp: getCurrentDateISO()
    };

    const formData = new FormData();
    if(selectedfile) formData.append('file', selectedfile);
    const jsonData = {collection:"consumtransactions", data:conTransObj, type:"addnew", oldPath:""}
    formData.append('jsonData', JSON.stringify(jsonData));
    try {
      await uploadFile({ formData, folder: folderName, tag:{type: 'CONSUMTRANS', id: 'LIST' } }).unwrap();
      await updateconsumfinal({
        consumable: selectedConsum[0]?.consumable, 
        partno: selectedConsum[0]?.partno, 
        store: user_current_office, 
        balanceQuantity: selectedConsum[0]?.quantity
      }).unwrap();
      
      // Success alert with better formatting
      alert(`✓ Consumable surrendered successfully!\n\nItem: ${selectedConsum[0]?.consumable}\nPart No: ${selectedConsum[0]?.partno}\nQuantity: ${selectedConsum[0]?.quantity}`);
      
      // Reset form only on success
      setEmailId("");
      setOffsigle();
      setSelectedUser({});
      setSelectedConsum([]);
      setSelectedFile(null);
      setAddSpecIndex(1);
      setSelectedUserbyOff();
      setSelectedOff1();
      setSelectedUser();
    } catch (error) {
      console.error("Error during transaction:", error);
      // Show error alert to user
      alert(`✗ Error: Failed to surrender consumable.\n\nItem: ${selectedConsum[0]?.consumable} (${selectedConsum[0]?.partno})\n\nError: ${error?.data?.message || error.message || 'Unknown error'}\n\nPlease try again.`);
    }
  }


  return (
    <Container>
      {(byEmailClicked || byOfficeClicked) && <BackArrowContainer onClick={backClickedHandler}><ArrowLeftIcon /><BackButtonSpan >Back </BackButtonSpan></BackArrowContainer>}
      <Wrapper>
        <AllWrapper>
          {!byEmailClicked && !byOfficeClicked && <OptionContainer onClick={(e) => setByEmailClicked(true)}><InnerContainer>Select User By Email</InnerContainer></OptionContainer>}
          {!byEmailClicked && !byOfficeClicked && <OptionContainer onClick={(e) => setByOfficeClicked(true)}><InnerContainer>Select User By Office </InnerContainer></OptionContainer>}
        </AllWrapper>
        <OptWrap>
          {!byOfficeClicked && byEmailClicked && <><SingleUserWrap>
            <EmailSelectWrap>
              <Autocomplete
                id="combo-box-demo"
                options={users? Object.values(users)?.map(elm => {return {label:elm.email, value:elm.id}}):[]}
                sx={{ width: 400 }}
                value={emailId}
                onChange={(event, newValue) => handleEmailSelect(event, newValue)}
                isOptionEqualToValue={(option, value) => option.value === value.value}
                renderInput={(params) => <TextField {...params} label="Enter user Email Id" />}
              />
            </EmailSelectWrap>
              {emailId?.label && <SingleoffCont>
                <SingleSelectCont>
                  <Autocomplete
                    id="combo-box-demo"
                    options={[{label:`${selectedUser?.office?.mainCharge} (Main Charge)`,value:selectedUser?.office?.mainCharge}].concat(selectedUser?.office?.additionalCharge.map(x => { return {label:x, value:x}}))}
                    sx={{ width: 400 }}
                    value={offsingle? offsingle: null}
                    onChange={(event, newValue) => {
                        setOffsigle(newValue);
                        setConsTransOption(prevState => ({
                          ...prevState,
                          to_office: [...prevState?.to_office, newValue?.value]  
                        }));
                        
                    }}
                    isOptionEqualToValue={(option, value) => option.value === value.value}
                    renderInput={(params) => <TextField {...params} label="Select Office" />}
                  />
                </SingleSelectCont>
              </SingleoffCont>}
            </SingleUserWrap>

            {(offsingle?.label?.length && selectedUser) && <StartAlignedSpan>{`Name: ${nameStringFn(selectedUser)}, Designation: ${selectedUser?.designation[offsingle?.value]}`}</StartAlignedSpan>}
            </>}
          </OptWrap>
          {<OptWrap>
            <MultiUserCont>
              {byOfficeClicked && !byEmailClicked && <MultiUserWrap>
                <OfficeSelectWrap>
                  <Autocomplete
                    id="combo-box-demo"
                    options={offices? Object.values(offices)?.map(elm => elm.name):[]}
                    sx={{ width: 400 }}
                    value={selectedOff1 || null}
                    onChange={(event, newValue) => handleSelectOffice(event, newValue)}
                    renderInput={(params) => <TextField {...params} label="Select Office" />}
                  />
                </OfficeSelectWrap>
                <UserSelectWrap>
                  <Autocomplete
                    id="combo-box-demo"
                    options={filteredUsers?.length? filteredUsers.map(x => {return {label:`${x?.email} (${nameStringFn(x)})- ${x?.designation[selectedOff1]}`, value:x} }):[]}
                    sx={{ width: 400 }}
                    value={selectedUserbyOff || null}
                    onChange={(event, newValue) => handleselectedUserbyOff(event, newValue)}
                    isOptionEqualToValue={(option, value) => option.id === value.id}
                    renderInput={(params) => <TextField {...params} label="Select User" />}
                  />
                  </UserSelectWrap>
                    {selectedUserbyOff && <StartAlignedSpan>{`Name: ${nameStringFn(selectedUserbyOff?.value)}, Designation: ${selectedUserbyOff?.value?.designation[selectedOff1]}`}</StartAlignedSpan>}
                </MultiUserWrap>}
            </MultiUserCont>
          </OptWrap>}

          {((byOfficeClicked || byEmailClicked) && (((emailId && offsingle)) || (selectedOff1 && selectedUserbyOff ))) && <OptWrap>
          <form onSubmit={handleFormSubmit} style={{marginTop:"20px"}}>
          {((emailId?.label && offsingle?.label?.length )|| (selectedOff1?.length && selectedUserbyOff?.label?.length )) && [...Array(addSpecIndex)].map((e, i) =>
            <Addconsumformcont key={i}>
            <LabelInputWrapper>
              <Autocomplete
                id="combo-box-demo"
                size="small"
                options={consTrans? [...new Set(Object.values(consTrans?.entities).map( x => x.consumable).sort())]
                    :[]}
                sx={{ width: 200 }}
                value={selectedConsum[i]?.["consumable"] || null}
                onChange={(event, newValue) => handleSelectConsum(event, newValue, i, "consumable")}
                renderInput={(params) => <TextField {...params} label="Select Consumable" />}
              />      
            </LabelInputWrapper>

            {selectedConsum[i]?.["consumable"]?.length && <LabelInputWrapper>
              <Autocomplete
                id="combo-box-demo"
                size="small"
                disabled = {Object.values(consumablemaster)?.find(elm => elm.consumable === selectedConsum[i]?.["consumable"])?.asset.includes("Not Applicable")}
                options={consumablemaster? Object.values(consumablemaster)?.find(elm => elm.consumable === selectedConsum[i]?.["consumable"])?.asset:[]}
                sx={{ width: 200 }}
                value={Object.values(consumablemaster)?.find(elm => elm.consumable === selectedConsum[i]?.["consumable"])?.asset.includes("Not Applicable")? "Not Applicable":(selectedConsum[i]?.["asset"] || null)}
                onChange={(event, newValue) => handleSelectConsum(event, newValue,i, "asset")}
                renderInput={(params) => <TextField {...params} label="Select Asset" />}
              />      
            </LabelInputWrapper>}

            {(selectedConsum[i]?.["asset"]?.length || Object.values(consumablemaster)?.find(elm => elm.consumable === selectedConsum[i]?.["consumable"])?.asset.includes("Not Applicable") ) && <LabelInputWrapper>
              <Autocomplete
                id="combo-box-demo"
                size="small"
                disabled = {consumablemaster && selectedConsum[i] &&
                  Object.values(consumablemaster)?.find(elm => elm.consumable === selectedConsum[i]?.["consumable"])?.asset.includes("Not Applicable")}
                options={
                  allassets
                    ? Object.values(allassets)
                      .filter(elm => elm.alloc_user === emailId?.value && elm.name === selectedConsum[i]?.["asset"])
                      .map(x => ({ label: x.oem_tag, value: x }))
                    : []
                }
                sx={{ width: 200 }}
                value={
                  Object.values(consumablemaster)
                    ?.find(elm => elm.consumable === selectedConsum[i]?.["consumable"])?.asset.includes("Not Applicable")
                    ? { label: "Not Applicable", value: "Not Applicable" }
                    : selectedConsum[i]?.["assettag"]         
                }
                onChange={(event, newValue) => handleSelectConsum(event, newValue,i, "assettag")}
                isOptionEqualToValue={(option, value) => option.value.oem_tag === value.value.oem_tag} // Compare based on oem_tag
                renderInput={(params) => <TextField {...params} label="Select Asset Tag" />}
              />      
            </LabelInputWrapper>}

            {(selectedConsum[i]?.["assettag"]?.label?.length || Object.values(consumablemaster)?.find(elm => elm.consumable === selectedConsum[i]?.["consumable"])?.asset.includes("Not Applicable")) && <LabelInputWrapper>
              <Autocomplete
                id="combo-box-demo"
                size="small"          
                options={
                  consTrans? [...new Set(Object.values(consTrans?.entities)?.map( x => x?.partnumber).sort())]
                    :[]
                }
                sx={{ width: 200 }}
                value={selectedConsum[i]?.["partno"] || null}
                onChange={(event, newValue) => handleSelectConsum(event, newValue,i, "partno")}
                renderInput={(params) => <TextField {...params} label="Select Consum Part No." />}
              />      
            </LabelInputWrapper>}

            {selectedConsum[i]?.["partno"]?.length && <LabelInputWrapper>
              <div><TextField
                id="outlined-basic"
                disabled={!(consumfinal?.[selectedConsum[i]?.partno]?.balance_order_quantity > 0)}
                size='small'
                name={`quantity`}
                onChange={(event, newValue) => handleSelectConsum(event, newValue,i, "quantity")}
                label="Quantity"
                value={selectedConsum[i]?.["quantity"]}
                variant="outlined"
                sx={{ width: 200 }} 
              /></div>

              { <span style={{ fontSize: '12px', color: 'red'}}>{consumfinal?.[selectedConsum[i]?.partno]?.balance_order_quantity > 0? `Available Quantity: ${Object.values(consTrans?.entities).filter( x => (x.partnumber === selectedConsum[i]?.partno) && (x.from_store === user_current_office)).reduce((sum, transaction) => sum + transaction.quantity, 0)}`:"Not Available"}</span>}                 
            </LabelInputWrapper>}
          </Addconsumformcont>
          )}
          {hasValidQuantity(selectedConsum) && <><UploadPdfWrapper>
            <InputFile type="file" onChange={handlePdfFileChange} ref={inputPdfFile}/>
            <CustomFileUploadButton htmlFor="file-upload" onClick={handlePdfUploadButtonClick}>
              Upload reference document as a single PDF only
            </CustomFileUploadButton>
            {selectedfile  && <><span>{selectedfile.name}</span><SelectFileReset type='button' onClick={() => deleteSelectFile()} >&times;</SelectFileReset><ViewButton type='button' onClick={handleviewFile}>View File</ViewButton></>}
          </UploadPdfWrapper>

        {(byOfficeClicked || byEmailClicked) && <Issuebutton type='submit' disabled={(isLoading || isUploading)}>Create Issue</Issuebutton>}</>}
        </form>
          </OptWrap>}


      </Wrapper>

    </Container>

    // <div>SurrenderConsum</div>
  )
}

export default SurrenderConsum